function i(s) {
  const n = s[0].clone().sub(s[1]);
  return s.map((t) => {
    const r = s[0].clone().sub(t);
    let e = r.lengthSq();
    return r.dot(n) < 0 && (e = -e), { point: t, distSq: e };
  }).sort((t, r) => t.distSq - r.distSq).map(({ point: t }) => t);
}
export {
  i as sortAlignedPoints
};
//# sourceMappingURL=index24.js.map
